module.exports = __webpack_public_path__ + "static/media/events.abd776df.png";